import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.replace.js";
// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert } from '@polkadot/util';
import { ed25519PairFromSeed } from "../../ed25519/index.js";
import { mnemonicValidate } from "../../mnemonic/index.js";
import { HARDENED, hdValidatePath } from "../validatePath.js";
import { ledgerDerivePrivate } from "./derivePrivate.js";
import { ledgerMaster } from "./master.js";
export function hdLedger(_mnemonic, path) {
  var words = _mnemonic.split(' ').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  });

  assert([12, 24, 25].includes(words.length), 'Expected a mnemonic with 24 words (or 25 including a password)');

  var _ref = words.length === 25 ? [words.slice(0, 24).join(' '), words[24]] : [words.join(' '), ''],
      _ref2 = _slicedToArray(_ref, 2),
      mnemonic = _ref2[0],
      password = _ref2[1];

  assert(mnemonicValidate(mnemonic), 'Invalid mnemonic passed to ledger derivation');
  assert(hdValidatePath(path), 'Invalid derivation path');
  var parts = path.split('/').slice(1);
  var seed = ledgerMaster(mnemonic, password);

  var _iterator = _createForOfIteratorHelper(parts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;
      var n = parseInt(p.replace(/'$/, ''), 10);
      seed = ledgerDerivePrivate(seed, n < HARDENED ? n + HARDENED : n);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return ed25519PairFromSeed(seed.slice(0, 32));
}